module.exports = __webpack_public_path__ + "public/assets/img/logo.c3347a5b.webp";